import { render, staticRenderFns } from "./DownloadLinks.vue?vue&type=template&id=2e4b7c98&scoped=true"
import script from "./DownloadLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadLinks.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DownloadLinks.vue?vue&type=style&index=0&id=2e4b7c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b7c98",
  null
  
)

export default component.exports